import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { View } from "@-/com.npmjs.react-native";

/**
 * One character of a revealed word: the glyph, its reading, and its own meaning beneath.
 *
 * Rendering the per-character back here (rather than only the word's overall meaning) is the
 * point of the word drill — the user is shown how each character contributes, and it is the same
 * set of meanings the typed answer is graded against (see `buildWordSentenceExpectedAnswer`).
 */
export function GraphemeBackTile({
  back,
  grapheme,
  isTarget = false,
  pinyin,
}: {
  /** The grapheme's meaning-card back; null when the catalog has none. */
  back: string | null;
  grapheme: string;
  /** Highlights the tile when it is part of the drilled word. */
  isTarget?: boolean;
  pinyin?: string | null;
}) {
  return (
    <View
      className={
        isTarget
          ? "min-w-18 items-center gap-1 rounded-xs border border-primary bg-primary/5 p-2"
          : "min-w-18 items-center gap-1 rounded-xs border border-border p-2"
      }
    >
      <Text className="font-sans text-[32px] text-foreground" colorVariant="default">
        {grapheme}
      </Text>
      {pinyin === undefined || pinyin === null || pinyin.length === 0 ? null : (
        <Text className="font-sans text-[13px]" colorVariant="muted">
          {pinyin}
        </Text>
      )}
      <Text className="text-center font-sans text-[13px]" colorVariant="default">
        {back === null || back.length === 0 ? "—" : back}
      </Text>
    </View>
  );
}
